$(document).ready(function(){
  $('.skipToContentBtn').on('click', function(){
    $('#main').find('button, a, input, select, textarea, [tabindex]:not([tabindex="-1"])').eq(0).focus();
  });
});